<template>
    <el-tabs :class="getPrimaryColor" v-model="activeTab" @tab-click="changeTab(activeTab)">
        <el-tab-pane label="Empresas" name="0" />
        <el-tab-pane label="Grupos econômicos" name="1" />
        <el-tab-pane label="Todos os usuários" name="2" v-if="this.$store.state.user.userAdm || ( this.$store.state.user.companyType == 3 && this.$store.state.user.partnerAdm )"/>
    </el-tabs>
</template>

<script>
export default {
    data() {
        return {
            activeTab: this.$store.state.tabs.userTab,
        }
    },
    methods: {
        changeTab(tab) {
            this.$store.commit('tabs/setUserTab', tab)
            this.$emit('update-tab', tab)
            return tab;
        }
    },
}
</script>

<style>

</style>
